import React from 'react'
import { connect } from 'react-redux'
import { Field, getFormValues, change } from 'redux-form'

import FieldInput, { InputType as type } from 'components/SemanticForm'
import { StdCard, RowFields } from 'components'
import { Cont } from './styled'

const AttachmentComponent = (props) => {

  const { 
    valueForm,
    change,
    // props
    isCreate = false,
    isEdit = false,
    isDetail = false,
  } = props

  const checkEditMode = () =>{
    return isCreate||isEdit
  }

  const fileChange = (key,value) =>{
    change('formBGCompanyRequest',key,value)
  }

  const getFileReference = () =>{
    if(valueForm.referenceDocumentType=='contract'){
      return valueForm.attachments.filter(x=>x.documentCode=='BGC01')
    }else{
      return valueForm.attachments.filter(x=>x.documentCode=='BGC02')
    }
  }

  const getFileBGC04 = () =>{
    return valueForm.attachments.filter(x=>x.documentCode=='BGC04')
  }

  const checkShowOldFile = () =>{
    if(isEdit||isDetail) return true
    if(isCreate){
      if(valueForm.requestType=='extend') return true
      else return false
    }
    return false
  }

  return (
    <StdCard title={<span className='stepTitle'>Attachment</span>}>
      <Cont>
        <RowFields style={{justifyContent:'space-around'}}>
          <Field 
            name={valueForm.referenceDocumentType=='contract'?'bgc01':'bgc02'} 
            label={valueForm.referenceDocumentType=='contract'?'Contract (PDF)':'Purchase Order (PDF)'}
            type={type.file}
            editable={checkEditMode()}
            multipleSelect={false}
            limitFileItem={1}
            component={FieldInput} 
            oldFiles={getFileReference()}
            showOldFile={checkShowOldFile()}
            change={fileChange}
            removeOldFiles={(index, id) => {
              let findIndex = valueForm.attachments.findIndex(x=>x.id==id)
              if(findIndex>=0) fileChange(`attachments[${findIndex}].deleted`,true)
            }}
            acceptFileType='.pdf'
            require />
          <Field 
            name='bgc04' 
            label='Other' 
            type={type.file}
            editable={checkEditMode()}
            component={FieldInput} 
            oldFiles={getFileBGC04()}
            showOldFile={checkShowOldFile()}
            change={fileChange}
            removeOldFiles={(index, id) => {
              let findIndex = valueForm.attachments.findIndex(x=>x.id==id)
              if(findIndex>=0) fileChange(`attachments[${findIndex}].deleted`,true)
            }}
          />
        </RowFields>
      </Cont>
    </StdCard>
  )
}

const mapStateToProps = (state, props) => {
  return {
    valueForm: getFormValues('formBGCompanyRequest')(state) || {},
  }
}

const mapDispatchToProps = {
  change
}

export default connect(mapStateToProps, mapDispatchToProps)(AttachmentComponent)
